import React, { useEffect, useRef, useState } from 'react';
import { Search, X } from 'lucide-react';
import Input from './Input';

// Input com ícone de busca, clear button, e debounce opcional.
// `onChange(value)` recebe o texto (após debounce se configurado).
const SearchInput = ({
  value,
  onChange,
  placeholder = 'Buscar…',
  debounceMs = 0,
  className = '',
  ...rest
}) => {
  const [internal, setInternal] = useState(value ?? '');
  const timerRef = useRef(null);

  useEffect(() => {
    setInternal(value ?? '');
  }, [value]);

  const emit = (v) => {
    if (!debounceMs) {
      onChange?.(v);
      return;
    }
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => onChange?.(v), debounceMs);
  };

  const handleChange = (e) => {
    const v = e.target.value;
    setInternal(v);
    emit(v);
  };

  const handleClear = () => {
    setInternal('');
    onChange?.('');
  };

  return (
    <Input
      value={internal}
      onChange={handleChange}
      placeholder={placeholder}
      leftIcon={<Search size={18} />}
      rightIcon={
        internal ? (
          <button
            type="button"
            onClick={handleClear}
            className="hover:text-app-text transition-colors pointer-events-auto"
            aria-label="Limpar busca"
          >
            <X size={18} />
          </button>
        ) : null
      }
      className={className}
      {...rest}
    />
  );
};

export default SearchInput;
